import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType,
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { channelsPlaylistsView_template } from "../components/templates/channelsPlaylistsView_template";
import { header } from "./header";

declare var ko: any;
declare var page: any;

export class channels_playlists_view extends vnModule_knockoutJS {
    protected channelView: channelsPlaylistsView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    protected getModuleName(): string {
        return "channels_playlists_view";
    }

    buildContent(): Array<Element> {
        this.channelView = new channelsPlaylistsView_template("channels_playlists_view", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("View Playlist");

        return [this.channelView.build()];
    }

    public fillPage(): void {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand) {
            this.channelView.setBrand(idBrand);
        }
        this.getPlaylist();
    }

    protected getPlaylist() {
        this.loadingIn(this.channelView.builtTemplate);
        let idPlaylist = this.getVnAppZone().getApp().params.idPlaylist;
        let usrReq_url: string = `/api/brand/${this.getVnAppZone().getApp().params.idBrand}/channels/playlists/get/${idPlaylist}`;
        let usrReq_params: Array<Array<string>> = [];
        let vm = this.channelView.getViewModelForRequest();
        usrReq_params.push(["data", ko.toJSON(vm)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetPlaylistReturn;
        this.XHRHdl.execute();
    }

    protected onGetPlaylistReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                let playlist = responseParsed.data[0];

                if(playlist && playlist.articles) {
                    playlist.articles.forEach((article) => {
                        if(article.dateMostRecentPublishedStatus && article.dateMostRecentPublishedStatus.date) {
                            article.dateMostRecentPublishedStatus = article.dateMostRecentPublishedStatus.date;
                        }
                    });
                }
                obj.channelView.setPlaylist(playlist);
            });
            obj.loadingOut(obj.channelView.builtTemplate);
        };
    }

    protected edit(id) {
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect(`/brand/${idBrand}/categorization/playlists/edit/${id}`);
    }

    protected cancel() {
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect(`/brand/${idBrand}/categorization/playlists/`);
    }

    protected showArticle(article) {
        if(article && article.id){
            const idBrand = this.getVnAppZone().getApp().params.idBrand;
            window.open(`/brand/${idBrand}/articles/view/${article.id}`, '_blank');
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/channels_playlists_view.ts